import { Component } from '@angular/core';

@Component({
  selector: 'app-report-wrapper',
  standalone: false,
  templateUrl: './report-wrapper.component.html',
  styleUrl: './report-wrapper.component.scss'
})
export class ReportWrapperComponent {

}
